/**
 * @generated SignedSource<<b47ad487517aaee57ffef7eb1cd101c3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CareProviderGroupType = "CHIROPRACTOR" | "DENTIST" | "DOCTOR" | "HOSPITAL" | "NONE" | "NUTRITIONIST" | "PHARMACY" | "PHYSIOTHERAPIST" | "PSYCHOTHERAPIST";
export type DayOfWeek = "FRIDAY" | "MONDAY" | "SATURDAY" | "SUNDAY" | "THURSDAY" | "TUESDAY" | "WEDNESDAY";
export type ReferralReason = "APPOINTMENT_POST_REGISTRATION" | "APPOINTMENT_REGISTRATION" | "EMERGENCY_POST_REGISTRATION" | "EMERGENCY_REGISTRATION" | "REFERRAL";
export type ReferredBy = "CARE_PROVIDER" | "MEDGATE" | "SELF";
export type WorkingType = "CLOSED" | "HOURLY" | "OPEN24_HOURS";
import { FragmentRefs } from "relay-runtime";
export type chTimeWindowFragment$data = ReadonlyArray<{
  readonly __typename: "ch_TimeWindow";
  readonly alternativeTriage: boolean | null;
  readonly alternativeTriageEntry: {
    readonly id: string;
    readonly phoneNumber: string;
    readonly reason: string;
  } | null;
  readonly createdAt: string;
  readonly createdBy: string | null;
  readonly dateFrom: any;
  readonly dateTo: any;
  readonly errorCorrection: boolean | null;
  readonly id: string;
  readonly internalComment: string | null;
  readonly involvesPreventionProgram: boolean;
  readonly patientId: string;
  readonly progressNoteId: string | null;
  readonly referenceDate: any | null;
  readonly referralReason: ReferralReason;
  readonly referralToCareProvider: {
    readonly additionalAddress: string | null;
    readonly billsVia: {
      readonly businessName: string | null;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly title: string | null;
    } | null;
    readonly businessName: string | null;
    readonly careProviderGroup: {
      readonly groupType: CareProviderGroupType;
    };
    readonly careProviderSpecialtyTranslations: ReadonlyArray<{
      readonly name: string;
    }>;
    readonly city: string | null;
    readonly country: {
      readonly countryName: string | null;
    } | null;
    readonly countryCode: string | null;
    readonly creditorCodeRegister: string | null;
    readonly detailedSchedule: ReadonlyArray<{
      readonly day: DayOfWeek;
      readonly periods: ReadonlyArray<{
        readonly end: string;
        readonly start: string;
      }> | null;
      readonly workingType: WorkingType;
    }> | null;
    readonly email: string | null;
    readonly firstName: string | null;
    readonly globalLocationNumber: number | null;
    readonly groupName: string | null;
    readonly id: string;
    readonly isMedgatePartnerNetworkMember: boolean | null;
    readonly isTakesNewPatients: boolean | null;
    readonly lastName: string | null;
    readonly network: {
      readonly name: string;
    } | null;
    readonly officialLanguageLookupTranslations: ReadonlyArray<{
      readonly isoLanguageName: string;
    }>;
    readonly phoneNumber: string | null;
    readonly postalCode: string | null;
    readonly relationBusinessName: string | null;
    readonly relationFirstName: string | null;
    readonly relationLastName: string | null;
    readonly relationTitle: string | null;
    readonly relationType: string | null;
    readonly streetAddress: string | null;
    readonly title: string | null;
    readonly website: string | null;
  } | null;
  readonly referralToCareProviderId: string | null;
  readonly referralToDoctorName: string | null;
  readonly referredBy: ReferredBy;
  readonly referredByExternalCareProviderId: string | null;
  readonly updatedAt: string | null;
  readonly updatedBy: string | null;
  readonly " $fragmentType": "chTimeWindowFragment";
}>;
export type chTimeWindowFragment$key = ReadonlyArray<{
  readonly " $data"?: chTimeWindowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"chTimeWindowFragment">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "language"
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "language"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "chTimeWindowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorCorrection",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referenceDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referredByExternalCareProviderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeTriage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CareProvider",
      "kind": "LinkedField",
      "name": "referralToCareProvider",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        (v2/*:: as any*/),
        (v3/*:: as any*/),
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": (v5/*:: as any*/),
          "kind": "ScalarField",
          "name": "groupName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v5/*:: as any*/),
          "concreteType": "SpecialtyTranslation",
          "kind": "LinkedField",
          "name": "careProviderSpecialtyTranslations",
          "plural": true,
          "selections": (v6/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v5/*:: as any*/),
          "concreteType": "OfficialLanguageLookupTranslation",
          "kind": "LinkedField",
          "name": "officialLanguageLookupTranslations",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isoLanguageName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CareProviderGroup",
          "kind": "LinkedField",
          "name": "careProviderGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "groupType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CountryLookup",
          "kind": "LinkedField",
          "name": "country",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": (v5/*:: as any*/),
              "kind": "ScalarField",
              "name": "countryName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creditorCodeRegister",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isMedgatePartnerNetworkMember",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTakesNewPatients",
          "storageKey": null
        },
        (v7/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "website",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "globalLocationNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postalCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "streetAddress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "additionalAddress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "relationType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "relationBusinessName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "relationFirstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "relationLastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "relationTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CareProvider",
          "kind": "LinkedField",
          "name": "billsVia",
          "plural": false,
          "selections": [
            (v1/*:: as any*/),
            (v3/*:: as any*/),
            (v4/*:: as any*/),
            (v2/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ch_Network",
          "kind": "LinkedField",
          "name": "network",
          "plural": false,
          "selections": (v6/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DaySchedule",
          "kind": "LinkedField",
          "name": "detailedSchedule",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "day",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "workingType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TimePeriod",
              "kind": "LinkedField",
              "name": "periods",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "start",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "end",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateFrom",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateTo",
      "storageKey": null
    },
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internalComment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralToCareProviderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralToDoctorName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referredBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "involvesPreventionProgram",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ch_AlternativeTriage",
      "kind": "LinkedField",
      "name": "alternativeTriageEntry",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v7/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reason",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ch_TimeWindow",
  "abstractKey": null
};
})();

(node as any).hash = "9ff7b1a87181b39dde7bd2def393918c";

export default node;
